import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import NFTNav from "../components/NavComponents/NFTNav";
import PerksList from "../components/desktop/PerksList";
import { io } from 'socket.io-client';
import { mintNFT, sendMessagePerk, airdropNFT } from '../utils/backendUtils';
import SocialConnectModalComponent from '../components/NavComponents/SocialConnectModalComponent'
import { getLoginInformation,
    setPaymentDetails,
    setWalletDetails,
    setSocialHandleInformation
} from '../utils/loginHelper';
import eventBus from '../utils/globalPubSub';
import Lottie from 'react-lottie';
import animationData from '../assets/loader.json';
import { useHistory } from "react-router-dom";
import { fethchGlipBox } from '../utils/backendUtils';


let listOfCompanies = [{'name': 'Affable', 'passId': '6245a10a3c4528caff894784'},
{'name': 'AffordPlan', 'passId': '6245a10a3c4528caff894785'},
{'name': 'Bookee', 'passId': '6245a10a3c4528caff894786'},
{'name': 'Collpoll', 'passId': '6245a10a3c4528caff894787'},
{'name': 'Dozee', 'passId': '6245a10a3c4528caff894788'},
{'name': 'Ezetap', 'passId': '6245a10a3c4528caff894789'},
{'name': 'Finagg', 'passId': '6245a10a3c4528caff89478a'},
{'name': 'Freo', 'passId': '6245a10a3c4528caff89478b'},
{'name': 'Glip', 'passId': '6245a10a3c4528caff89478c'},
{'name': 'HackerEarth', 'passId': '6245a10a3c4528caff89478d'},
{'name': 'Hiration', 'passId': '6245a10a3c4528caff89478e'},
{'name': 'Hitwicket', 'passId': '6245a10a3c4528caff89478f'},
{'name': 'KnightFIntech', 'passId': '6245a10a3c4528caff894790'},
{'name': 'KredX', 'passId': '6245a10a3c4528caff894791'},
{'name': 'mFine', 'passId': '6245a10a3c4528caff894792'},
{'name': 'MyGate', 'passId': '6245a10a3c4528caff894793'},
{'name': 'Niyo', 'passId': '6245a10a3c4528caff894794'},
{'name': 'OTO', 'passId': '6245a10a3c4528caff894795'},
{'name': 'PlanetSpark', 'passId': '6245a10a3c4528caff894796'},
{'name': 'Poshn', 'passId': '6245a10a3c4528caff894797'},
{'name': 'Quizizz', 'passId': '6245a10a3c4528caff894798'},
{'name': 'Revos', 'passId': '6245a10a3c4528caff894799'},
{'name': 'SmartOwner', 'passId': '6245a10a3c4528caff89479a'},
{'name': 'Styledod', 'passId': '6245a10a3c4528caff89479b'},
{'name': 'Sunstone', 'passId': '6245a10a3c4528caff89479c'},
{'name': 'SurveySparrow', 'passId': '6245a10a3c4528caff89479d'},
{'name': 'Swifter', 'passId': '6245a10a3c4528caff89479e'},
{'name': 'Synup', 'passId': '6245a10a3c4528caff89479f'},
{'name': 'Tracxn', 'passId': '6245a10a3c4528caff8947a0'},
{'name': 'Tranzact', 'passId': '6245a10a3c4528caff8947a1'},
{'name': 'Vidgyor', 'passId': '6245a10a3c4528caff8947a2'},
{'name': 'Waggle', 'passId': '6245a10a3c4528caff8947a3'},
{'name': 'WheelsEye', 'passId': '6245a10a3c4528caff8947a4'},
{'name': 'Winuall', 'passId': '6245a10a3c4528caff8947a5'},
{'name': 'WisdomCircle', 'passId': '6245a10a3c4528caff8947a6'},
{'name': 'Zupay', 'passId': '6245a10a3c4528caff8947a7'},
{'name': 'Zuper', 'passId': '6245a10a3c4528caff8947a8'},
{'name': 'Prime', 'passId': '624650713c4528caff8947a9'},
];


const getPassId = (name) => {
    console.log(name)
    return listOfCompanies.filter((item) => {
        if(item.name == name) return true;
    });

};

const url = window.location;
let domain = (new URL(url));
domain = domain.origin;


const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

const Mobile = styled.div`
  display: none;
  @media only screen and (max-device-width: 480px) {
    display: flex;
    height: 96vh;
    flex-direction: column;
  }
`;

const Title = styled.div`
    font-style: normal;
    font-weight: bold;
    font-size: 26px;

    display: flex;
    align-items: center;

    color: #FFFFFF;
    text-align: center;

`;

const Price = styled.div`
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    display: flex;
    align-items: center;

    color: #FFFFFF;
`;

const Subtitle = styled.div`
    font-family: IBM Plex Mono;
    font-style: normal;
    font-weight: 600;
    font-size: 15.5866px;
    line-height: 120%;
    /* or 19px */
   
    letter-spacing: -0.03em;

    color: #FFFFFF;

    color: #fff;
   
`;


const ActionBoxTitle = styled.div`
    font-family: IBM Plex Mono;
    font-style: normal;
    font-weight: bold;
    color: #FFFFFF;
    text-transform: uppercase;
`;

const ActionBoxSubtitle = styled.div`
    font-family: IBM Plex Mono;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 145%;
    /* or 20px */

    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;

    opacity: 0.4;
    margin-top: 15px;
    margin-bottom: 24px;
`;


const ActionBox = styled.div`
    background: rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    color: #FFFFFF;
    padding: 50px 40px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const Desktop = styled.div`
  display: none;
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
    height: 100vh;
    opacity: 0.8
    align-items: flex-end;
    padding-left: 50px;
  }
`;


const GradientButton = styled.div`
    background: linear-gradient(95.39deg, #001AFF 3.78%, #DB00FF 100%);
    border-radius: 12px;
    padding: 13px;
    width: 100%;
    color: #fff;
    display: flex;
    justify-content: center;
    margin-top: 31px;
`;


const Description = styled.div`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    opacity: 0.4;
    margin-bottom: 32px;
`;


const BotBar = styled.div`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    background: rgba(255, 255, 255, 0.04);
    padding: 15px;
    flex-direction: column;
    width: 100%;
`;

const BotBarTitle = styled.span`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;

    color: #FFFFFF;

    opacity: 0.4;
    margin-bottom: 5px;
`;

const BotBarCount = styled.span`
    font-family: 'IBM Plex Mono';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 31px;
    display: flex;
    align-items: center;
    text-align: right;

    color: #FFFFFF;

`;

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

export default function PrimeMint(props) {
    const [socialConnectModalOpen,
        setSocialConnectModalOpen] = useState(false);
    const [connected, setIsConnected] = useState(false);
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState({});
    let {company} = useParams();
    if(company == 'prime')
        company = capitalizeFirstLetter(company);    
    const history = useHistory();
    const [glipbox, setGlipbox] = useState();
    const [name, setName] = useState();
    const [error, setError] = useState();
    
    // Fetch data for remaing glipboxes
    // useEffect(() => {
    //     const fetchApi = async () => {
    //         const glipboxData = await fethchGlipBox(company);
    //         console.log('glipboxdata==============', glipboxData)
    //         if(glipboxData.success)
    //             setGlipbox(glipboxData);
    //     };

    //     fetchApi();
    // }, []);

    
    const handleLogin = async (loginDetails)=>{
        setIsConnected(true);
        setUser(loginDetails.user);        
    }

    const handleLogout = ()=> {
        setIsConnected(false);
        setUser({});
        setSocialConnectModalOpen(false)
    }

    
    const handleClaimButtonClick = async () => {
        if(!name) {
            setError('Please enter name!')
            return;
        }
        setLoading(true)        
        console.log('setSocialConnectModalOpen(true)')
        let loginData = getLoginInformation();
        console.log(loginData)
        if(loginData){
            // handleLogin(loginData);
            // Make backend API call to mint NFT        
            const companyData = getPassId(company);
            console.log(loginData, companyData[0].passId, 'passId');
            // const response = await airdropNFT(company, loginData.user, name, companyData[0].passId);
            const response = await airdropNFT('primevp.nft', loginData.user, name, companyData[0].passId);
            console.log('airdtop============', response)
            if(response.success)
                history.push(`/address/${loginData.user.username}`);
            else
                setError(response.message);
            console.log('mint api call')
            setLoading(false);
        }
        setSocialConnectModalOpen(true);
    };

    useEffect(()=>{
        let loginData = getLoginInformation();
        if(loginData){
            handleLogin(loginData);
        }
        eventBus.on("user-logged-in",(data)=>{
            handleLogin(data);
        });
        eventBus.on("user-logged-out",()=>{
            handleLogout();
        })
        return ()=>{
            eventBus.remove("user-logged-in");
            eventBus.remove("user-logged-out");
        }
    },[]);

    
    return (
        <>
        <Mobile>
            <NFTNav		    
                userChainId={1}
                showTabs={false}
                ownedTab={false}
            />
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', height: '65vh', alignSelf: 'center', flexDirection: 'column'}}>
                <div style={{display: 'flex', flex: 2, flexWrap: 'wrap', paddingTop: 20, maxWidth: 260}}>
                    <img
                        autoPlay
                        loop
                        style={{width: '100%', zIndex: -1, maxHeight: 260, borderRadius: 12}}
                        src={`https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/prime-anniversary/PVP_NFT_${company}.gif`}
                    />
                </div>
                <div style={{padding: 24, width: '100%'}}>
                    <div style={{
                        width: '100%',
                        borderRadius: 12,
                        display: 'flex',
                        flex: 1,
                        background: 'rgba(255, 255, 255, 0.08)',
                        alignItems: 'center',
                        flexDirection: 'column',
                        }}>
                        <Title style={{marginTop: 73, marginBottom: 18, textTransform: 'capitalize'}}>{company}'s NFT</Title>
                        {/* <Description>Mysterious box... <br></br>What will it bring<br></br>to it’s holder?</Description> */}

                        <input
                            onChange={(e) => {console.log(e.target.value);setName(e.target.value)}}
                            style={{
                                border: '1px solid rgba(255,255,255, 0.3)',
                                borderRadius: 12,
                                padding: 8,
                                width: '80%',
                                background: 'transparent'
                            }} placeholder="Please enter name..."/>
                            {error && <span style={{color: 'red', marginTop: 2, width: '80%'}}>{error}</span>}

                        {loading ?
                         <GradientButton className="hover" style={{marginBottom: 32, width: '80%', padding: 3}}><div style={{display: 'flex'}}>
                             <Lottie style={{}}
                                options={defaultOptions}
                                height={40}
                                width={40}
                            />
                            <span style={{marginTop: 10}}>Minting...</span>
                        </div>
                        </GradientButton> :
                        <GradientButton className="hover" onClick={() => handleClaimButtonClick()} style={{marginBottom: 32, width: '80%'}}>MINT
                        </GradientButton>
                        }

                        {/* <BotBar>
                            <BotBarTitle>Boxes Claimed</BotBarTitle>
                            {glipbox && <BotBarCount>{glipbox.data.minted}/{glipbox.data.supply} minted</BotBarCount>}
                        </BotBar> */}
                    </div>
                </div>
            </div>
        </Mobile>       
        <Desktop style={{}}>
            <NFTNav		    
                userChainId={1}
                showTabs={false}
                ownedTab={false}
            />
            {/* <Title style={{justifyContent: 'center', width: '100%', marginTop: 40}}>CLAIM YOUR NFT PERKS</Title> */}
            <div style={{display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', width: '100%', height: '65vh', alignSelf: 'center',}}>
                <div style={{display: 'flex', flexWrap: 'wrap'}}>
                    <img
                        autoPlay
                        loop
                        style={{width: '100%', zIndex: -1, maxHeight: 260, borderRadius: 12, maxWidth: 260}}
                        src={`https://live-nft-hosted-assets.s3.ap-south-1.amazonaws.com/prime-anniversary/PVP_NFT_${company}.gif`}
                    />
                </div>
                <div style={{right: 120, width: 370, borderRadius: 12, display: 'flex', background: 'rgba(255, 255, 255, 0.08)', alignItems: 'center', flexDirection: 'column'}}>
                    <Title style={{marginTop: 73, marginBottom: 18, textTransform: 'capitalize'}}>{company}'s NFT</Title>
                    {/* <Description>Mysterious box... <br></br>What will it bring<br></br>to it’s holder?</Description> */}

                    {/* <GradientButton onClick={() => handleClaimButtonClick()} style={{marginBottom: 32, width: '80%'}}>CLAIM BOX</GradientButton> */}

                    {/* <BotBar> */}
                        {/* <BotBarTitle>Enter Name</BotBarTitle> */}
                        {/* {glipbox && <BotBarCount>{glipbox.data.minted}/{glipbox.data.supply} minted</BotBarCount> } */}
                        <input
                            onChange={(e) => {console.log(e.target.value);setName(e.target.value)}}
                            style={{
                                border: '1px solid rgba(255,255,255, 0.3)',
                                borderRadius: 12,
                                padding: 8,
                                width: '80%',
                                background: 'transparent'
                            }} placeholder="Please enter name..."/>
                            {error && <span style={{color: 'red', marginTop: 2, width: '80%'}}>{error}</span>}
                    {/* </BotBar> */}

                    {loading ?
                         <GradientButton className="hover" style={{marginBottom: 32, width: '80%', padding: 3}}><div style={{display: 'flex'}}>
                             <Lottie style={{}}
                                options={defaultOptions}
                                height={40}
                                width={40}
                            />
                            <span style={{marginTop: 10}}>Minting...</span>
                        </div>
                        </GradientButton> :
                        <GradientButton className="hover" onClick={() => handleClaimButtonClick()} style={{marginBottom: 32, width: '80%'}}>MINT
                        </GradientButton>
                        }
                    {/* <BotBar>
                        <BotBarTitle>Boxes Claimed</BotBarTitle>
                        {glipbox && <BotBarCount>{glipbox.data.minted}/{glipbox.data.supply} minted</BotBarCount> }
                    </BotBar> */}
                </div>
            </div>
            
            <br></br>
            {!connected && <SocialConnectModalComponent
                isOpen={socialConnectModalOpen}
                setIsOpen={(val)=>{setSocialConnectModalOpen(val)} }
            >
            </SocialConnectModalComponent>}
        </Desktop>
        </>
    );
}

